import { useState, useEffect, useRef } from "react";
import styled from "styled-components";

const StyledTextarea = styled.textarea`
  margin-top: ${({ marginTop }) => marginTop || "4rem"};
  height: ${({ height }) => height || "20rem"};
  max-height: ${({ height }) => height || "20rem"};
  line-height: ${({ lineHeight }) => lineHeight || "1.8rem"};
  text-align: center;
  box-sizing: border-box;
  width: calc(${({ width }) => width || "60%"});
  min-width: calc(${({ width }) => width || "60%"});
  aspect-ratio: 360 / 150;
  background: rgba(255, 255, 255, 0);
  border: 0px;
  resize: none;
  color: #ab9b14;
  font-size: 1rem;
  outline: none;
  white-space: pre-wrap;
`;

const DivInput = () => {
    const [msg, set_msg] = useState("");
    const divRef = useRef(null);

    return (
        <StyledTextarea value={msg} onChange={e => {
            let lines = e.target.value.split('\n');
            console.log("lines",lines)
            if (lines.length <= 8)
                set_msg(e.target.value);
        }}></StyledTextarea>
    );
};

export default DivInput;
